import React, {memo} from 'react'
import { ParsedCell } from './ListCell'
import {TModuleListCell} from '../_types'
import {useSetupContext} from '../../../helpers/SetupContext'
import useCellNavigation from '../hooks/useCellNavigation'
import useCellFilter from '../hooks/useCellFilter'

export const CardCell = memo((props: TModuleListCell) => {
    const {article, type, row, page, filterable, suffix, setFilter, setIndividualPage, isNewUI, is_hex} = props

    const {context} = useSetupContext()

    const { isDataAsHref, handleCellClick, navigate } = useCellNavigation(
        type,
        row,
        page,
        filterable
    )

    const { handleCellDataClick } = useCellFilter(
        article,
        setFilter,
        filterable
    )

    return (
        <div className={`moduleCard_cell ${type} ${isDataAsHref ? ' link' : ''}`}
             onClick={handleCellClick}
        >
            <ParsedCell
                article={article}
                type={type}
                row={row}
                context={context}
                filterable={filterable}
                suffix={suffix}
                navigate={navigate}
                handleClick={handleCellDataClick}
                setIndividualPage={setIndividualPage}
                isNewUI={isNewUI}
                is_hex={is_hex}
            />
        </div>
    )
})